import React, { useRef, useEffect, useState } from "react";
import { getHomeData, registrarAnalyticsSlider, toggleSeguirComercio, obtenerDetalleComercio, registrarTap, guardarUbicacionHistorial, registrarTrafico } from "../api";
import RecomiendaBox from "../components/Recomienda";
import ReferidosModal from "../components/ReferidosModal";
import BottomNavigation from "../components/BottomNavigation";
import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import ClimaWidget from "../components/ClimaWidget";
import { useNavigate, useNavigationType } from "react-router-dom";
import CategoriasScroll from "../components/CategoriasScroll";
import GaleriaHorizontal from "../components/SliderPrincipal";
import ImagenConFallBack from "../components/SliderFallback";
import { v4 as uuidv4 } from "uuid";
import { Autoplay, Navigation, Pagination, Scrollbar, EffectCoverflow } from 'swiper/modules';
import { calcularDistancia } from "../utils/geo";
import 'swiper/css';
import { useBottomSheet } from "../context/BottomSheetContext";
import 'swiper/css/effect-coverflow';
import { toast } from "react-hot-toast";
import DestinoSlide from "../components/DestinoSlide";
import SugerenciaItem from "../components/PodriaInteresarteHome";
import { motion, AnimatePresence } from "framer-motion";
import 'swiper/css/navigation';
import { useAuth } from "../context/AuthContext";
import 'swiper/css/pagination';
import { esIOSWebView } from "../utils/detectarIOS";
import 'swiper/css/scrollbar';
import { useDetalleComercioStore } from '../stores/detalleComercioStore';
import { useDynamicSplash } from "../hooks/useDynamicSplash";

const Gober = () => {
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const userId = userData?.id || null;
  const [animacionCargada, setAnimacionCargada] = useState(false);
  const [categoriasScroll, setCategoriasScroll] = useState(null);
  const [loadingHome, setLoadingHome] = useState(true);
  const showSplash = useDynamicSplash(loadingHome, { delayMs: 120, minVisibleMs: 120 });
  const [sliders, setSliders] = useState([]);
  const [historias, setHistorias] = useState([]);
  const { openBottomSheet } = useBottomSheet();
  const cintilloRef = useRef(null);
  const [imagenSeleccionada, setImagenSeleccionada] = useState(null);
  const tipoNavegacion = useNavigationType();
  const [showReferidos, setShowReferidos] = useState(false);
  const [comerciosConDistancia, setComerciosConDistancia] = useState([]);
  const [comercios, setComercios] = useState([]);
  const [clima, setClima] = useState(null);
  const [categorias, setCategorias] = useState([]);
  const [userLocation, setUserLocation] = useState(null);
  const [destinos, setDestinos] = useState([]);
  const [isReady, setIsReady] = useState(false);
  const viewedOnce = useRef(new Set());
  const [cintillo, setCintillo] = useState(null);
  const [showGame, setShowGame] = useState(null);
  const navigate = useNavigate();
  const { user } = useAuth();
  const estaLogueado = user && user.id;
  const { guardarDetalle } = useDetalleComercioStore.getState();

  useEffect(() => {
    if (!comercios || comercios.length === 0) return;

    comercios.forEach((comercio, index) => {
      setTimeout(async () => {
        const detalle = await obtenerDetalleComercio(comercio.id_sucursal, user?.id || 0);
        if (detalle?.success) {
          guardarDetalle(comercio.id, detalle);
        }
      }, index * 500);
    });
  }, [comercios]);

  const fetchData = async () => {
    try {
      const data = await getHomeData(user?.id || 0);

      const latUser = localStorage.getItem("userLat");
      const lngUser = localStorage.getItem("userLng");

      const comerciosFinal = (data.comercios || []).map((comercio) => {
        let distancia = "Acceso a la ubicación requerido.";

        if (latUser && lngUser && comercio.lat && comercio.lng) {
          distancia = calcularDistancia(
            parseFloat(latUser),
            parseFloat(lngUser),
            parseFloat(comercio.lat),
            parseFloat(comercio.lng)
          );
        }

        return {
          ...comercio,
          seguido: Number(comercio.seguido), // forzado a número
          distancia,
        };
      });

      setComercios(comerciosFinal);
      setComerciosConDistancia(comerciosFinal);
      setClima(data.clima || null);
      setSliders(data.sliders || []);
      setCategoriasScroll(data.categoriasScroll || null);
      setDestinos(data.destinos || []);
      setCategorias(data.categorias || []);
      setHistorias(data.historias || []);
      setCintillo(data.cintillo || null);
      setShowGame(data.showGame[0].description);
    } catch (error) {
      console.error("Error al cargar datos desde la API:", error);
    } finally {
      setIsReady(true);
      setAnimacionCargada(true);
      setLoadingHome(false);
    }
  };

  useEffect(() => {
    document.body.style.overflow = showSplash ? "hidden" : "auto";
  }, [showSplash]);

  const handleNotificaciones = () => {
    if (!user || !user.id) {
      toast.dismiss();
      toast.error("Debes iniciar sesión para ver tus notificaciones.");
      return;
    }
    navigate("/notificaciones");
  };

  useEffect(() => {
    let anonId = localStorage.getItem("anon_id");
  
    if (!anonId) {
      anonId = uuidv4();
      localStorage.setItem("anon_id", anonId);
    }
  
    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler("registrarDispositivo", {
        anon_id: anonId,
      });
    }
  }, []);  

  const handleToggleSeguir = async (id_comercio) => {
    if (!user || !user.id) {
      toast.dismiss();
      toast.error("Debes iniciar sesión para seguir comercios.");
      return;
    }
  
    const result = await toggleSeguirComercio(user.id, id_comercio);
  
    if (result.success) {
      setComerciosConDistancia((prev) =>
        prev.map((c) =>
          c.id === id_comercio
            ? { ...c, seguido: !!result.followed }
            : c
        )
      );
      toast.dismiss();
      toast.success(result.message);
    } else {
      toast.dismiss();
      toast.error(result.message || "No se pudo seguir el comercio.");
    }
  };  

  const handleVerMapa = async () => {
    const lat = localStorage.getItem("userLat");
    const lng = localStorage.getItem("userLng");
  
    if (lat && lng) {
      await guardarUbicacionHistorial(lat, lng, user?.id || 0);
      navigate("/mapa");
      return;
    }
  
    const esIOS = esIOSWebView();
  
    if (esIOS) {
      const tienePermiso = await window.flutter_inappwebview?.callHandler("verificarUbicacion");
  
      if (!tienePermiso) {
        toast.dismiss();
        toast.error("Se necesita acceso a tu ubicación para ver el mapa.");
        return;
      }
  
      const lat = await window.flutter_inappwebview.callHandler("obtenerLat");
      const lng = await window.flutter_inappwebview.callHandler("obtenerLng");
  
      if (lat && lng) {
        localStorage.setItem("userLat", lat);
        localStorage.setItem("userLng", lng);
        await guardarUbicacionHistorial(lat, lng, user?.id || 0);
        navigate("/mapa");
        return;
      }
  
      toast.dismiss();
      toast.error("No se pudo obtener la ubicación.");
      return;
    }
  
    // Android / Web
    const tienePermiso = await window.flutter_inappwebview?.callHandler("verificarUbicacion");
  
    if (!tienePermiso) {
      toast.dismiss();
      toast.error("Se necesita acceso a tu ubicación para ver el mapa.");
      return;
    }
  
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          localStorage.setItem("userLat", latitude);
          localStorage.setItem("userLng", longitude);
          await guardarUbicacionHistorial(latitude, longitude, user?.id || 0);
          navigate("/mapa");
        },
        (error) => {
          toast.dismiss();
          toast.error("No se pudo obtener la ubicación.");
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
        }
      );
    } else {
      toast.dismiss();
      toast.error("Tu dispositivo no soporta geolocalización.");
    }
  };  

  useEffect(() => {
    if (user !== undefined) {
      const latUser = localStorage.getItem("userLat");
      const lngUser = localStorage.getItem("userLng");
      registrarTrafico("home", latUser, lngUser);
    }
  }, [user]);
  
  useEffect(() => {
    const cache = sessionStorage.getItem("homeLoaded");
    const isBack = tipoNavegacion === "POP";
    setLoadingHome(true);

    fetchData().then(() => {
      if (!isBack && !cache) {
        sessionStorage.setItem("homeLoaded", "1");
      }
    });
  }, []);  

  useEffect(() => {
    if (!cintilloRef.current || !cintillo || !cintillo.imagen) return;
  
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
  
        if (entry.isIntersecting) {
          registrarTap(null, "cintillo", userId || null, null, cintillo.enlace || null, 1);
        }
      },
      { threshold: 0.5 }
    );
  
    observer.observe(cintilloRef.current);
  
    return () => observer.disconnect();
  }, [cintillo]);  

  return (
    <>
       {showSplash && (
        <div id="splash">
          <img src="/assets/images/loading.gif" loading="lazy" style={{ width: 300 }} alt="Cargando..."/>
        </div>
      )}
      {!showSplash && animacionCargada && (
      <motion.div
        initial={!animacionCargada ? { y: "100%", opacity: 0 } : false}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: "100%", opacity: 0 }}
        transition={{ duration: !animacionCargada ? 0.7 : 0, ease: "easeInOut" }}
      >
        <div className="app-container">
        <header className="app-header">
            <div className="left">
                <svg  id="open-search" onClick={openBottomSheet} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m17 17l4 4M3 11a8 8 0 1 0 16 0a8 8 0 0 0-16 0"/></svg>
            </div>
            <div className="center">
              <img src="/assets/images/logocap.png" loading="lazy" alt="Ubikalo!" className="logo" />
            </div>
            <div className="right" onClick={handleNotificaciones}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M18.134 11C18.715 16.375 21 18 21 18H3s3-2.133 3-9.6c0-1.697.632-3.325 1.757-4.525S10.41 2 12 2q.507 0 1 .09M19 8a3 3 0 1 0 0-6a3 3 0 0 0 0 6m-5.27 13a2 2 0 0 1-3.46 0" />
                </svg>
            </div>
          </header>
          <GaleriaHorizontal historias={historias} mostrarEmergencias={true}/>
          {categoriasScroll && (
            <CategoriasScroll data={categoriasScroll}/>
          )}
      {!isReady ? (
        <>
        <Swiper
          modules={[Autoplay, Navigation, Pagination, Scrollbar]}
          slidesPerView={1.1}
          spaceBetween={10}
          centeredSlides={true}
          loop={true}
        >
          {[...Array(3)].map((_, i) => (
            <SwiperSlide key={i}>
              <div className="slider-skeleton"></div>
            </SwiperSlide>
          ))}
        </Swiper>
        </>
      ) : sliders.length > 0 && (
        <Swiper
          modules={[Autoplay, Navigation, Pagination, Scrollbar]}
          slidesPerView={1.1}
          spaceBetween={10}
          onSlideChange={(swiper) => {
            const current = sliders[swiper.realIndex];
            if (current && !viewedOnce.current.has(current.id)) {
              viewedOnce.current.add(current.id);
              registrarAnalyticsSlider(current.id, "vista", userId);
            }
          }}
          centeredSlides={true}
          direction="horizontal"
          loop={true}
          autoplay={{
            delay: 5000, 
            disableOnInteraction: false,
          }}
          speed={1300}
          pagination={{
            el: '.swiper-pagination',
            clickable: true,
          }}
          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }}
          scrollbar={{
            el: '.swiper-scrollbar',
          }}
          breakpoints={{
            768: {
              slidesPerView: 1.2,
              spaceBetween: 10,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            1440: {
              slidesPerView: 1.8,
              spaceBetween: 10,
            },
          }}
        >
          {sliders.map((item) => (
            <SwiperSlide key={item.id} onClick={async () => {
              try {
                await registrarAnalyticsSlider(item.id, "click", userId);
              } catch (error) {
                console.error("Error registrando analytics:", error);
              }
              navigate(`/comercio/app/${item.id_sucursal}`, {
                state: { from: "home" },
              });
            }}
             className="slider-card">
              <ImagenConFallBack
                src={item.imagen}
                alt={item.titulo}
                className="slider-image"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
      {comerciosConDistancia.length > 0 && (
        <div className="suggestions-container">
          <h3>Sugerencias para ti</h3>
          {comerciosConDistancia.map((comercio) => (
            <SugerenciaItem
              key={comercio.id}
              comercio={comercio}
              estaLogueado={estaLogueado}
              handleToggleSeguir={handleToggleSeguir}
            />
          ))}
        </div>
      )}
      <div className="btn-center-container">
        <button className="btn-ver-mapa" onClick={handleVerMapa}>
          Ver en el mapa 
          <svg xmlns="http://www.w3.org/2000/svg" width="20.5" height="16" viewBox="0 0 41 32">
            <g fill="currentColor" strokeWidth="1" stroke="currentColor">
              <path d="M9.239 31.927c.009.006.021.003.03.009A.5.5 0 0 0 9.5 32a.5.5 0 0 0 .132-.018L20.5 29.016l10.868 2.966A.5.5 0 0 0 31.5 32a.5.5 0 0 0 .23-.065c.01-.005.021-.003.03-.009l9-5.5a.5.5 0 0 0 .22-.563l-4.984-17.5a.5.5 0 0 0-.726-.3l-4.962 2.784a.501.501 0 0 0 .491.872l4.409-2.475l4.707 16.526l-8.015 4.899l-1.904-15.231a.5.5 0 0 0-.993.124l1.907 15.259L21 28.116v-2.73a.5.5 0 0 0-1 0v2.73l-9.911 2.705l1.907-15.259a.5.5 0 1 0-.993-.124L9.1 30.669l-8.015-4.898L5.792 9.246l4.409 2.475a.501.501 0 0 0 .491-.872L5.729 8.064a.496.496 0 0 0-.725.3L.02 25.864a.5.5 0 0 0 .22.563z" />
              <path d="M20.161 23.368a.5.5 0 0 0 .675.003C21.169 23.068 29 15.882 29 8.5C29 3.733 25.267 0 20.5 0S12 3.733 12 8.5c0 7.254 7.828 14.56 8.161 14.868M20.5 1C24.775 1 28 4.224 28 8.5c0 6.097-5.993 12.337-7.497 13.807C19.002 20.82 13 14.498 13 8.5C13 4.224 16.225 1 20.5 1" />
              <path d="M25 8.5C25 6.019 22.981 4 20.5 4S16 6.019 16 8.5s2.019 4.5 4.5 4.5S25 10.981 25 8.5M20.5 12c-1.93 0-3.5-1.57-3.5-3.5S18.57 5 20.5 5S24 6.57 24 8.5S22.43 12 20.5 12" />
            </g>
          </svg>
        </button>
      </div>

      {cintillo && cintillo.imagen && (
        <div ref={cintilloRef} onClick={(e) => {
          e.preventDefault();
          const enlace = cintillo.enlace?.trim() || "#";
          registrarTap(0, "cintillo", userId || null, null, enlace).finally(() => {
            if (window.flutter_inappwebview) {
              window.flutter_inappwebview.callHandler("abrirEnlaceExterno", enlace);
            } else {
              const finalUrl = enlace.startsWith("http") ? enlace : `https://${enlace}`;
              window.open(finalUrl, "_blank", "noopener,noreferrer");
            }
          });
        }}
        >
          <a href={cintillo.enlace || "#"} target="_blank" rel="noopener noreferrer">
            <img
              src={cintillo.imagen}
              loading="lazy"
              style={{
                width: "calc(100% - 20px)",
                marginLeft: 10,
                marginRight: 10,
                marginBottom: 25
              }}
              alt="Cintillo publicitario"
            />
          </a>
        </div>
    )}
    {categorias.length > 0 && (
      <>
        <h3 className="categories-title">Explora por categoría</h3>
        <div className="categories-container">
          <div className="categories-icons">
            {categorias.slice(0, 4).map((cat) => (
              <div className="category-icon" key={cat.id}  onClick={() => navigate(`/comercios/${cat.id}`, { state: { from: "featured" } })}>
                <img
                  src={cat.icono ? cat.icono : "/assets/images/default.png"}
                  alt={cat.nombre}
                  loading="lazy"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/assets/images/default.png"; 
                  }}
                />
              </div>
            ))}
          </div>
          <div className="all-categories" onClick={() => navigate("/categorias")}>
            <span>Ver todas las categorías</span>
          </div>
        </div>
      </>
    )}
      <h3 className="categories-title mt-4">¿Qué visitar en Quetzaltenango?</h3>
      <Swiper
        modules={[Autoplay]}
        className="home-coverflow"
        grabCursor={true}
        breakpoints={{
          0: {
            slidesPerView: 1.1,
          },
          360: {
            slidesPerView: 1.3,
          },
          480: {
            slidesPerView: 1.6,
          },
          768: {
            slidesPerView: 2.5,
          },
          1024: {
            slidesPerView: 3.5,
          }
        }}
        loop={true}
        watchSlidesProgress={true}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        speed={1600}
      >
        {destinos.map((item, index) => {
          return (
            <SwiperSlide key={item.id}>
              <DestinoSlide item={item} isFirst={index === 0} />
            </SwiperSlide>
          );
        })}
      </Swiper>

      <center>
        <button className="view-all-cities" type="button" onClick={() => navigate("/destinos",)}>
          Explora todos los destinos
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1">
              <path strokeDasharray="20" strokeDashoffset="20" d="M3 12h17.5">
                <animate fill="freeze" attributeName="stroke-dashoffset" dur="0.2s" values="20;0" />
              </path>
              <path strokeDasharray="12" strokeDashoffset="12" d="M21 12l-7 7M21 12l-7 -7">
                <animate fill="freeze" attributeName="stroke-dashoffset" begin="0.2s" dur="0.2s" values="12;0" />
              </path>
            </g>
          </svg>
        </button>
      </center>
      {showGame === "1" && (
      <div className="card-juegos">
        <div className="botones-juegos">
          <button className="btn-juego" onClick={() => navigate(`/memoria`)}>Juega memoria</button>
          <button className="btn-juego" onClick={() => navigate(`/juegoruleta`)}>Juega ruleta</button>
        </div>
      </div>
      )}
      <RecomiendaBox />
      <BottomNavigation />
      {showReferidos && (
        <ReferidosModal user={user} onClose={() => setShowReferidos(false)} />
      )}
    </div>
    </motion.div>
    )}
    </>
  );
};

export default Gober;
